<div class="modal-header main-modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="dismissModal()">&times;</button>
    <h4 class="modal-title wrap-text-in">{{actionLabel}}</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12">
            <app-move-job-match-step
                [jobMatchId]="jobMatchId"
                [candidateId]="candidateId"
                [notifyUsers]="true"
                [meetingScheduleId]="meetingScheduleId"
                [externalMeetingId]="externalMeetingCallId"
                moveType="Forward"
                (saveCallback)="moveCandidateCallback()"
                [label]="actionLabel"
                [sourceScreen]="sourceScreen"
                [formalizeActivityPayload]="formalizeActivityPayload">
            </app-move-job-match-step>
        </div>
    </div>
</div>
